export default {
  // Title
  title: "Tip",

  // Description
  description:
    "The following list contains addresses that failed to update their balance. Click the Update Balance Again button below to continue querying the balance.",

  // Statistics
  totalCount: "Total",
  totalData: "data records",

  // Table Columns
  serialNumber: "Serial Number",
  blockchain: "Blockchain",
  address: "Address",

  // Buttons
  back: "Back",
  updateBalanceAgain: "Update Balance Again",
};
